/**
 * Customer Registration Extension
 * Handles saving mobile number and SMS marketing preferences
 * after a customer account is created
 */

// Immediately execute this to test if the script is loading at all
DBLogger.log('Customer Registration script loaded - ' + new Date().toISOString());

// Add direct event handler to debug SMS checkbox
document.addEventListener('DOMContentLoaded', function() {
  DBLogger.log('DOMContentLoaded fired for registration script');
  
  // Direct setup of SMS checkbox toggle (outside of any function)
  setTimeout(function() {
    const smsCheckbox = document.getElementById('signup-sms-marketing');
    const mobileField = document.getElementById('mobile-number-field');
    
    DBLogger.log('Direct SMS checkbox setup:', {
      checkboxFound: !!smsCheckbox,
      mobileFieldFound: !!mobileField,
      path: window.location.pathname
    });
    
    if (smsCheckbox && mobileField) {
      DBLogger.log('Setting up direct event listener on SMS checkbox');
      
      // Force show the mobile field if already checked
      if (smsCheckbox.checked) {
        DBLogger.log('SMS checkbox is initially checked');
        mobileField.style.display = 'block';
      }
      
      smsCheckbox.addEventListener('change', function() {
        DBLogger.log('SMS checkbox changed - direct handler:', this.checked);
        if (this.checked) {
          mobileField.style.display = 'block';
          document.getElementById('mobile_number').focus();
        } else {
          mobileField.style.display = 'none';
          document.getElementById('mobile_number').value = '';
        }
      });
      
      // Also handle clicks directly
      smsCheckbox.addEventListener('click', function() {
        DBLogger.log('SMS checkbox clicked - direct handler');
        setTimeout(() => {
          DBLogger.log('Checked state after click:', this.checked);
          if (this.checked) {
            mobileField.style.display = 'block';
          } else {
            mobileField.style.display = 'none';
          }
        }, 10);
      });
    }
  }, 500); // Short delay to ensure DOM is fully loaded
});

const CustomerRegistration = {
  init: function() {
    DBLogger.log('CustomerRegistration init called');
    
    // Check if we're on a page with the registration form
    if (window.location.pathname.includes('/register')) {
      DBLogger.log('On registration page, setting up form handlers');
      this.setupRegistrationForm();
    }
    
    // If we're on the account page, we might have just registered
    if (window.location.pathname.includes('/account')) {
      DBLogger.log('On account page, checking for new registration');
      this.checkForRegistrationFlag();
    }
  },
  
  checkForRegistrationFlag: function() {
    DBLogger.log('Checking for registration flag...');
    DBLogger.log('Current path:', window.location.pathname);
    
    // Check if we have a new registration flag in localStorage
    const newRegistration = localStorage.getItem('newRegistration') === 'true';
    DBLogger.log('New registration flag in localStorage:', newRegistration);
    
    if (newRegistration) {
      DBLogger.log('Registration flag found, preparing to send data...');
      
      // Check if data has already been sent
      if (localStorage.getItem('marketingPreferencesSent') === 'true') {
        DBLogger.log('Marketing preferences already sent, cleaning up');
        this.clearStoredData();
        return;
      }
      
      // Use a delay to ensure customer data is available
      DBLogger.log('Waiting for customer data to be available...');
      setTimeout(() => {
        // Set a flag to prevent duplicate calls
        localStorage.setItem('marketingPreferencesSent', 'true');
        this.sendMarketingPreferences();
      }, 1500);
    }
  },
  
  setupRegistrationForm: function() {
    // Look for the registration form with various possible selectors
    const regForm = document.querySelector('form[action="/account"], form[action*="create_customer"], form#create_customer');
    
    if (regForm) {
      DBLogger.log('Registration form found:', regForm);
      
      // Add hidden input to debug Shopify's redirect behavior
      const hiddenDebugField = document.createElement('input');
      hiddenDebugField.type = 'hidden';
      hiddenDebugField.name = 'debug_redirect';
      hiddenDebugField.value = 'true';
      regForm.appendChild(hiddenDebugField);
      
      // Attach submit handler
      regForm.addEventListener('submit', this.handleFormSubmit.bind(this));
      
      // Set up the SMS checkbox toggle for mobile number field
      const smsCheckbox = document.getElementById('signup-sms-marketing');
      const mobileField = document.getElementById('mobile-number-field');
      
      if (smsCheckbox && mobileField) {
        DBLogger.log('Found SMS checkbox and mobile field, setting up toggle');
        
        // Initial state setup - show mobile field if checkbox is checked
        if (smsCheckbox.checked) {
          mobileField.style.display = 'block';
          DBLogger.log('SMS checkbox is initially checked, showing mobile field');
        }
        
        // Toggle mobile field visibility when checkbox changes
        smsCheckbox.addEventListener('change', function() {
          DBLogger.log('SMS checkbox changed, checked:', this.checked);
          if (this.checked) {
            mobileField.style.display = 'block';
            // Set focus to the mobile field for better UX
            document.getElementById('mobile_number').focus();
            DBLogger.log('Showed mobile field and focused input');
          } else {
            mobileField.style.display = 'none';
            // Clear the mobile number field when unchecked
            document.getElementById('mobile_number').value = '';
            DBLogger.log('Hid mobile field and cleared input');
          }
        });
      } else {
        DBLogger.error('SMS checkbox or mobile field not found', {
          smsCheckbox: !!smsCheckbox,
          mobileField: !!mobileField
        });
      }
    } else {
      DBLogger.error('Registration form not found using any selector');
    }
  },
  
  handleFormSubmit: function(e) {
    DBLogger.log('Form submitted');
    
    // Get SMS subscription status
    const smsCheckbox = document.getElementById('signup-sms-marketing');
    if (!smsCheckbox) {
      DBLogger.error('SMS checkbox not found on form submission');
      return; // Don't prevent form submission if we can't find elements
    }
    
    const smsMarketing = smsCheckbox.checked;
    DBLogger.log('SMS marketing checked:', smsMarketing);
    
    let mobileNumber = '';
    
    // Only proceed with mobile number if SMS marketing is checked
    if (smsMarketing) {
      const mobileInput = document.getElementById('mobile_number');
      if (!mobileInput) {
        DBLogger.error('Mobile number input not found');
        return;
      }
      
      mobileNumber = mobileInput.value;
      DBLogger.log('Mobile number:', mobileNumber);
      
      if (mobileNumber) {
        localStorage.setItem('customerMobile', mobileNumber); // Use localStorage instead of sessionStorage
        localStorage.setItem('customerSmsMarketing', 'true');
        DBLogger.log('Stored mobile number and SMS preference in local storage');
      } else {
        // If SMS is checked but no mobile number, prevent submission
        e.preventDefault();
        alert('Please enter your mobile number to receive SMS updates.');
        mobileInput.focus();
        return;
      }
    } else {
      // Clear any stored mobile data if SMS marketing is not checked
      localStorage.setItem('customerSmsMarketing', 'false');
      DBLogger.log('SMS marketing not checked, set flag to false');
    }
    
    // Store email marketing preference
    const emailCheckbox = document.getElementById('signup-email-marketing');
    if (!emailCheckbox) {
      DBLogger.error('Email marketing checkbox not found');
      return;
    }
    
    // Store customer email if available (from the form)
    const emailInput = document.getElementById('email');
    if (emailInput && emailInput.value) {
      localStorage.setItem('customerEmail', emailInput.value);
      DBLogger.log('Stored customer email in localStorage:', emailInput.value);
    }
    
    const emailMarketing = emailCheckbox.checked;
    localStorage.setItem('customerEmailMarketing', emailMarketing.toString());
    localStorage.setItem('newRegistration', 'true');
    localStorage.setItem('marketingPrefsTimestamp', Date.now().toString());
    DBLogger.log('Stored preferences in localStorage with timestamp');
    
    // Create a backup preferences object and store as JSON
    const prefsObject = {
      email: emailInput ? emailInput.value : '',
      emailMarketing: emailMarketing,
      smsMarketing: smsMarketing,
      mobileNumber: mobileNumber,
      timestamp: Date.now()
    };
    
    localStorage.setItem('marketingPrefsBackup', JSON.stringify(prefsObject));
    DBLogger.log('Created backup preferences object:', prefsObject);
    
    // Form submission continues normally
    DBLogger.log('Form submission proceeding');
  },
  
  sendMarketingPreferences: function() {
    DBLogger.log('Sending marketing preferences');
    
    let mobileNumber, smsMarketing, emailMarketing;
    
    // Try to get from the backup object first
    const backupPrefs = localStorage.getItem('marketingPrefsBackup');
    if (backupPrefs) {
      try {
        const prefsObject = JSON.parse(backupPrefs);
        DBLogger.log('Found backup preferences object:', prefsObject);
        
        mobileNumber = prefsObject.mobileNumber;
        smsMarketing = prefsObject.smsMarketing;
        emailMarketing = prefsObject.emailMarketing;
        
        // Also get the email if available
        if (prefsObject.email) {
          localStorage.setItem('customerEmail', prefsObject.email);
        }
      } catch (e) {
        DBLogger.error('Error parsing backup preferences:', e);
      }
    }
    
    // Fall back to individual items if backup object failed
    if (mobileNumber === undefined) {
      mobileNumber = localStorage.getItem('customerMobile');
      smsMarketing = localStorage.getItem('customerSmsMarketing') === 'true';
      emailMarketing = localStorage.getItem('customerEmailMarketing') === 'true';
    }
    
    DBLogger.log('Retrieved preferences:', {
      mobileNumber,
      smsMarketing,
      emailMarketing
    });
    
    // First try to get customer info from the theme object (most reliable)
    let customerEmail = null;
    let customerId = null;
    
    // Try getting customer info from window.theme.customer first (this is our Liquid-injected data)
    if (window.theme && window.theme.customer) {
      customerEmail = window.theme.customer.email;
      customerId = window.theme.customer.id;
      DBLogger.log('Found customer info in window.theme.customer:', { 
        email: customerEmail, 
        id: customerId 
      });
    }
    
    // Only fallback to other methods if theme.customer doesn't have the data
    if (!customerEmail || !customerId) {
      // Try getting customer info from the window.Shopify global object
      if (window.Shopify && window.Shopify.customer) {
        customerEmail = window.Shopify.customer.email;
        customerId = window.Shopify.customer.id;
        DBLogger.log('Found customer info in Shopify global object:', { 
          email: customerEmail, 
          id: customerId 
        });
      }
      
      // If not available, try the window.customer object
      if ((!customerEmail || !customerId) && window.customer) {
        customerEmail = window.customer.email;
        customerId = window.customer.id;
        DBLogger.log('Found customer info in window.customer:', { 
          email: customerEmail, 
          id: customerId 
        });
      }
      
      // Look for customer info in HTML if not in JS objects
      if (!customerEmail || !customerId) {
        DBLogger.log('Customer object not available in window objects, checking DOM...');
        
        // Try to find customer information from the account page content
        const accountPage = document.body.textContent || '';
        
        // Try to extract ID from data in body or specific elements
        document.querySelectorAll('[data-customer-id], .customer-id, .account-id').forEach(el => {
          const id = el.getAttribute('data-customer-id') || el.textContent.trim();
          if (id && /^\d+$/.test(id)) {
            customerId = id;
            DBLogger.log('Found customer ID in DOM:', customerId);
          }
        });
        
        // For email, check for common customer account elements
        document.querySelectorAll('.customer-email, .account-email, .customer-info').forEach(el => {
          if (el.textContent && el.textContent.includes('@')) {
            const emailMatch = el.textContent.match(/[\w.-]+@[\w.-]+\.\w+/);
            if (emailMatch) {
              customerEmail = emailMatch[0];
              DBLogger.log('Found customer email in DOM:', customerEmail);
            }
          }
        });
        
        // If still no customer data available, use from localStorage if set
        if (!customerEmail) {
          customerEmail = localStorage.getItem('customerEmail');
          DBLogger.log('Using email from localStorage:', customerEmail);
        }
      }
    }
    
    DBLogger.log('Customer info summary:', {
      hasEmail: !!customerEmail,
      hasId: !!customerId,
      email: customerEmail,
      id: customerId
    });
    
    // If we don't have customer email, we can't continue
    if (!customerEmail) {
      DBLogger.error('Customer email not available, aborting API call');
      return;
    }
    
    // Determine whether to use the test or production endpoint
    let endpointUrl;
    
    // If running on a production storefront domain, use production URL
    if (window.location.hostname.includes('dharmabums.com.au') || window.location.hostname.includes('darmha.com')) {
      endpointUrl = 'https://webhooks.dharmabums.com.au/api/Customer/UpdateMarketingStatus';
    } else {
      // For development/testing environments
      endpointUrl = 'http://localhost:4031/api/Customer/UpdateMarketingStatus';
    }
    
    DBLogger.log('Using endpoint URL:', endpointUrl);
    DBLogger.log('Current hostname:', window.location.hostname);
    
    // Force debug to true for all requests in development
    const debug = !(window.location.hostname.includes('dharmabums.com.au') || window.location.hostname.includes('darmha.com'));
    
    const requestData = {
      CustomerId: customerId,
      Email: customerEmail, // Adding email explicitly
      EmailMarketingStatus: emailMarketing,
      SmsMarketingStatus: smsMarketing,
      SmsMarketingMobileNumber: mobileNumber || '',
      Debug: debug
    };
    
    DBLogger.log('Sending data to API:', requestData);
    
    // Send data to the external API endpoint
    fetch(endpointUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Shop-Domain': window.theme.shop.permanentDomain || 'dharmabums.myshopify.com'
      },
      mode: 'cors',
      credentials: 'same-origin',
      body: JSON.stringify(requestData)
    })
    .then(response => {
      DBLogger.log('API response received:', {
        status: response.status,
        ok: response.ok
      });
      
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`);
      }
      
      return response.text().then(text => {
        if (!text) {
          DBLogger.log('Empty response received, but status OK');
          return {};
        }
        try {
          return JSON.parse(text);
        } catch(e) {
          DBLogger.log('Response is not JSON but status OK:', text);
          return { message: text };
        }
      });
    })
    .then(data => {
      DBLogger.log('Marketing preferences saved successfully:', data);
      // Clear stored data after successful submission
      this.clearStoredData();
    })
    .catch(error => {
      DBLogger.error('Error saving marketing preferences:', error);
    });
  },
  
  clearStoredData: function() {
    DBLogger.log('Clearing stored marketing data');
    // Clear both localStorage and sessionStorage to be safe
    localStorage.removeItem('customerMobile');
    localStorage.removeItem('customerSmsMarketing');
    localStorage.removeItem('customerEmailMarketing');
    localStorage.removeItem('newRegistration');
    localStorage.removeItem('marketingPreferencesSent');
    localStorage.removeItem('customerEmail');
    localStorage.removeItem('marketingPrefsBackup');
    localStorage.removeItem('marketingPrefsTimestamp');
    
    sessionStorage.removeItem('customerMobile');
    sessionStorage.removeItem('customerSmsMarketing');
    sessionStorage.removeItem('customerEmailMarketing');
    sessionStorage.removeItem('newRegistration');
    sessionStorage.removeItem('marketingPreferencesSent');
    sessionStorage.removeItem('customerEmail');
  }
};

// Initialize the module when the DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  CustomerRegistration.init();
});

// Also try initializing immediately in case DOMContentLoaded already fired
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  DBLogger.log('Document already ready, initializing immediately');
  CustomerRegistration.init();
}